module.exports = new __parcel__URL__("placeholder-vertical.b2b5a09d.svg").toString();